import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ isLoading: _ctx.isLoading, isPending: _ctx.isPending, isRunning: _ctx.isRunning, success: _ctx.success, failure: _ctx.failure })))
  ]))
}